export default __webpack_public_path__ + "static/media/EditDisable.b5d3962d.svg";